import {CLStore} from 'common/src/redux/store';
import initializeBrandGuidelinesAgents from './initializeBrandGuidelinesAgents';

function initializeBrandGuidelines(store: CLStore) {
  initializeBrandGuidelinesAgents(store);
}

export default initializeBrandGuidelines;
